import { notify } from 'utils/reduxUtils';

export const types = {
  CLOSE: 'workflows/workStepModal/CLOSE',
  OPEN_ERROR: 'workflows/workStepModal/OPEN_ERROR',
  OPEN_REQUEST: 'workflows/workStepModal/OPEN_REQUEST',
  OPEN_SUCCESS: 'workflows/workStepModal/OPEN_SUCCESS',
  SAVE_ERROR: 'workflows/workStepModal/SAVE_ERROR',
  SAVE_REQUEST: 'workflows/workStepModal/SAVE_REQUEST',
  SAVE_SUCCESS: 'workflows/workStepModal/SAVE_SUCCESS',
  SET_WORK_STEP: 'workflows/workStepModal/SET_WORK_STEP',
};

export const workStepsModal = {
  close: () => ({
    type: types.CLOSE,
  }),
  setWorkStep: ({ workStep }) => ({
    type: types.SET_WORK_STEP,
    payload: { workStep },
  }),
};

export const open = {
  error: notify(
    (error) => ({
      type: types.OPEN_ERROR,
      payload: error,
    }),
    'Failed to edit work step',
  ),
  request: ({ workStepId, callBack, mode }) => ({
    type: types.OPEN_REQUEST,
    payload: {
      workStepId,
      callBack,
      mode,
    },
  }),
  success: () => ({
    type: types.OPEN_SUCCESS,
  }),
};

export const save = {
  error: notify(
    (error) => ({
      type: types.SAVE_ERROR,
      payload: error,
    }),
    'Failed to save work step',
  ),
  request: ({ name, updateExistingQuoteItems }) => ({
    type: types.SAVE_REQUEST,
    payload: { name, updateExistingQuoteItems },
  }),
  success: notify(
    ({ workStep }) => ({
      type: types.SAVE_SUCCESS,
      payload: { workStep },
    }),
    'Successfully saved work step',
  ),
};
